module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/pui-react-lists/~/babel-runtime/core-js/object/create.js
// module id = 3213
// module chunks = 0